import {ChangeDetectorRef, Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {AuthServicesService} from 'mclane-webauth-lib';
import {StoreListService} from '~/app/core/common/services/store-list.service';
import {process, State} from '@progress/kendo-data-query';
import {Store} from '~/app/core/common/models/store';
import {CellClickEvent, DataStateChangeEvent, PageChangeEvent} from '@progress/kendo-angular-grid';
import 'rxjs-compat/add/observable/defer';
import {ProfileCategoriesService} from '~/app/core/common/services/profile-categories.service';
import {ConfirmationService} from '~/app/core/common/services/confirmation.service';
import {ApplicationSettingsHelper} from '~/app/shared/helpers/application-settings-helper';
import {ProfileService} from '~/app/core/common/services/profile.service';

@Component({
    selector: 'app-store-list',
    templateUrl: './store-list.component.html',
    styleUrls: ['./store-list.component.scss']
})
export class StoreListComponent implements OnInit {

    public columns: any[] = [ {field: 'identity', title: 'Store'}, {
        field: 'status',
        title: 'Order Status'
    }, {field: 'address', title: 'Address/DC'}, {field: 'city', title: 'City'}, {
        field: 'state',
        title: 'State'
    }, {field: 'zip', title: 'Zip', format: '{0:c}'}];
    public value: any = [];
    username: string;
    public totalPrice = 0.00;
    public state: State = {
        skip: 0,
        take: 50,

    };
    loading = false;
    storeList: any;
    private stores: Store[] = [];

    constructor(private router: Router, private Auth: AuthServicesService, public _storeListService: StoreListService,
                private ref: ChangeDetectorRef, private _confirmationService: ConfirmationService,private profileService: ProfileService,
                private profileCategoriesService: ProfileCategoriesService, private _applicationSettingsHelper: ApplicationSettingsHelper) {
    }

    async ngOnInit() {
        this.loading = true;
        this.username = this.Auth.getUsername();
        this.storeList = this._storeListService.storeList;
        this.loading = false;
    }

    onSelect(store: Store) {
        this.updateStoreSection(store).then(r => r);
        this.router.navigate(['/']);
    }

    async updateStoreSection(store: Store) {
        localStorage.setItem('store_selected', this.username.toUpperCase() + '-' + store.customerId);
        this._storeListService.pickedStore = store;
        await this.profileCategoriesService.getCustomerCategories();
        this._applicationSettingsHelper.setCustomerId(store.customerId.toString());
        this._confirmationService.getStoreConfirmation().then(r => r);
        return store;
    }

    sendSelectedOrders() {
    }

    onSelectionChange($event) {
        // console.log('sample=' + JSON.stringify($event) +  $event.selectedRows[0].dataItem.customerId);
    }

    rowCallback({dataItem, index}) {
        if (this._storeListService.pickedStore === undefined) {
            return 0;
        }
    }

    gridCellClicked($event: CellClickEvent) {
        this.onSelect($event.dataItem);
    }

    pageChange($event: PageChangeEvent) {
        this.state.skip = $event.skip;
        this.storeList = process(this._storeListService.storeList, this.state);
    }

    dataStateChange(state: DataStateChangeEvent) {
        this.state = state;
        this.storeList = process(this._storeListService.storeList, this.state);
        this.ref.detectChanges();
    }
}
